import { FlashMessage } from './model';
import { FlashMessagesActions, FlashMessagesActionTypes } from './actions';

export interface FlashMessagesState {
    messages: FlashMessage[];
}

const initialState: FlashMessagesState = {
    messages: []
};

export function flashMessagesReducer(
    state: FlashMessagesState = initialState,
    action: FlashMessagesActions
): FlashMessagesState {
    switch (action.type) {
        case FlashMessagesActionTypes.ADD_FLASH_MESSAGE:
            return {
                messages: [...state.messages, action.payload.message]
            };
        case FlashMessagesActionTypes.REMOVE_FLASH_MESSAGE:
            return {
                messages: state.messages.filter(msg => msg.uid !== action.payload.uid)
            };
        case FlashMessagesActionTypes.CLEAR_FLASH_MESSAGES:
            return {
                messages: []
            };
        default:
            return state;
    }
}
